/**
 *
 * Asynchronously loads the component for AnimalTypes
 *
 */

import { lazyLoad } from 'utils/loadable';

export const AnimalTypesPage = lazyLoad(
  () => import('./index'),
  module => module.AnimalTypesPage,
);
